var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerQr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 214",
    width: 215,
    height: 214,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "customer_qr-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.s0 { fill: #ffffff } \r\n\t\t.s1 { fill: #000000 } \r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m-22.4-22.4h259.8v259.8h-259.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m76.6 11.9q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.4-0.6 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 10.1v-4.8q0-0.3-0.1-0.6-0.2-0.4-0.4-0.6-0.3-0.3-0.6-0.4-0.3-0.1-0.7-0.1h-4.7q-0.4 0-0.7 0.1-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.6-0.1 0.3-0.1 0.6v6.6h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m118.2 11.9q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.3-0.6 0.2-0.3 0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.3 10.1v-4.8q0-0.3-0.2-0.6-0.1-0.4-0.3-0.6-0.3-0.3-0.6-0.4-0.3-0.1-0.7-0.1h-4.8q-0.3 0-0.6 0.1-0.4 0.1-0.6 0.4-0.3 0.2-0.4 0.6-0.1 0.3-0.1 0.6v6.6h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 5.3c0-0.9 0.8-1.7 1.8-1.7h4.7c1 0 1.8 0.8 1.8 1.7v4.8c0 1-0.8 1.8-1.8 1.8h-4.7c-1 0-1.8-0.8-1.8-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m76.6 11.9h-4.7q-0.4 0-0.7 0.1-0.3 0.2-0.6 0.4-0.2 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.7q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.4 0.3 0.1 0.7 0.1h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 11.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m93.3 20.2q0.3 0 0.6-0.1 0.4-0.2 0.6-0.4 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 20.2q-0.4 0-0.7-0.1-0.3-0.2-0.6-0.4-0.2-0.3-0.3-0.6-0.2-0.3-0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m96.8 11.9q-0.4 0-0.7 0.1-0.3 0.2-0.6 0.4-0.2 0.3-0.3 0.6-0.2 0.3-0.2 0.7v6.5h8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 11.9h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 11.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.3 18.4q0 0.4-0.2 0.7-0.1 0.3-0.3 0.6-0.3 0.2-0.6 0.4-0.3 0.1-0.7 0.1h-6.5v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 22v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m76.6 28.5q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.6 0.1-0.3 0.1-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 20.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 20.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 20.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m105.1 20.2h-1.8v1.8q0-0.4 0.2-0.7 0.1-0.3 0.4-0.6 0.2-0.2 0.5-0.4 0.4-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m76.6 28.5h-4.7q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.3-0.2 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.8q0 0.3 0.1 0.6 0.2 0.4 0.4 0.6 0.3 0.3 0.6 0.4 0.3 0.1 0.7 0.1h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 35.1q0 0.3-0.1 0.6-0.2 0.4-0.4 0.6-0.3 0.3-0.6 0.4-0.3 0.1-0.7 0.1h-6.5v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 28.5h-1.8v1.8q0-0.4 0.2-0.7 0.1-0.3 0.3-0.6 0.3-0.2 0.6-0.3 0.3-0.2 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 30.3v-1.8h-1.7q0.3 0 0.6 0.2 0.4 0.1 0.6 0.3 0.3 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 35.1q0 0.3 0.2 0.6 0.1 0.4 0.3 0.6 0.3 0.3 0.6 0.4 0.3 0.1 0.7 0.1h4.8q0.3 0 0.7-0.1 0.3-0.1 0.5-0.4 0.3-0.2 0.4-0.6 0.1-0.3 0.1-0.6v-6.6h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 30.3c0-1 0.7-1.8 1.7-1.8h4.8c1 0 1.8 0.8 1.8 1.8v4.8c0 0.9-0.8 1.7-1.8 1.7h-4.8c-1 0-1.7-0.8-1.7-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m130.1 28.5q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.3-0.2 0.3-0.4 0.6-0.1 0.3-0.1 0.7v6.5h8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m143.1 28.5q0.4 0 0.7 0.2 0.3 0.1 0.6 0.3 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7v6.5h-8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 43.4v-4.8q0-0.4-0.1-0.7-0.1-0.3-0.4-0.5-0.2-0.3-0.6-0.4-0.3-0.2-0.6-0.2h-4.8q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.4-0.2 0.2-0.3 0.5-0.2 0.3-0.2 0.7v6.5h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 38.6c0-1 0.8-1.8 1.8-1.8h4.8c1 0 1.8 0.8 1.8 1.8v4.8c0 1-0.8 1.7-1.8 1.7h-4.8c-1 0-1.8-0.7-1.8-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m126.5 45.1q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.3-0.5 0.2-0.4 0.2-0.7v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.3 36.8h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 43.4q0 0.3-0.1 0.7-0.2 0.3-0.4 0.5-0.3 0.3-0.6 0.4-0.3 0.1-0.7 0.1h-6.5v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 51.7v-4.8q0-0.3-0.1-0.7-0.2-0.3-0.4-0.5-0.3-0.3-0.6-0.4-0.3-0.2-0.7-0.2h-4.7q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.5-0.1 0.4-0.1 0.7v6.6h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 45.1h8.3v8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m118.2 45.1h-4.8q-0.3 0-0.7 0.2-0.3 0.1-0.5 0.4-0.3 0.2-0.4 0.5-0.1 0.4-0.1 0.7v4.8q0 0.3 0.1 0.7 0.1 0.3 0.4 0.5 0.2 0.3 0.5 0.4 0.4 0.2 0.7 0.2h6.6v-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 45.1h8.3v8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 51.7q0 0.3-0.1 0.7-0.2 0.3-0.4 0.5-0.3 0.3-0.6 0.4-0.3 0.2-0.7 0.2h-6.5v-8.4h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m138.4 45.1h-1.8v1.8q0-0.3 0.1-0.7 0.2-0.3 0.4-0.5 0.3-0.3 0.6-0.4 0.3-0.2 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 60q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.3 0.3 0.2 0.7 0.2h4.7q0.4 0 0.7-0.2 0.3-0.1 0.6-0.3 0.2-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-6.5h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 60q0 0.4 0.2 0.7 0.1 0.3 0.3 0.6 0.3 0.2 0.6 0.3 0.3 0.2 0.7 0.2h4.8q0.3 0 0.6-0.2 0.4-0.1 0.6-0.3 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-6.5h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 60v-4.8q0-0.3-0.2-0.6-0.1-0.4-0.4-0.6-0.2-0.3-0.5-0.4-0.4-0.1-0.7-0.1h-4.8q-0.3 0-0.7 0.1-0.3 0.1-0.5 0.4-0.3 0.2-0.4 0.6-0.2 0.3-0.2 0.6v6.6h8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 55.2v-1.7h-1.8q0.4 0 0.7 0.1 0.3 0.1 0.6 0.4 0.2 0.2 0.3 0.6 0.2 0.3 0.2 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 60q0 0.4 0.1 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.6 0.3 0.3 0.2 0.6 0.2h4.8q0.4 0 0.7-0.2 0.3-0.1 0.6-0.3 0.2-0.3 0.3-0.6 0.2-0.3 0.2-0.7v-6.5h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m130.1 53.5h-1.8v1.7q0-0.3 0.1-0.6 0.2-0.4 0.4-0.6 0.3-0.3 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 60v-4.8q0-0.3-0.1-0.6-0.2-0.4-0.4-0.6-0.3-0.3-0.6-0.4-0.3-0.1-0.7-0.1h-4.7q-0.4 0-0.7 0.1-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.6-0.1 0.3-0.1 0.6v6.6h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 61.8h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m113.4 70.1q-0.3 0-0.7-0.1-0.3-0.2-0.5-0.4-0.3-0.3-0.4-0.6-0.1-0.3-0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 68.3q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.4 0.3 0.1 0.7 0.1h4.7q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-6.5h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m5.3 70.1q-0.3 0-0.6 0.1-0.4 0.2-0.6 0.4-0.3 0.3-0.4 0.6-0.1 0.3-0.1 0.7v6.5h8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m11.9 70.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m20.2 70.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m28.5 70.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m38.6 78.4h4.8q0.3 0 0.7-0.1 0.3-0.2 0.5-0.4 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-4.7q0-0.4-0.1-0.7-0.1-0.3-0.4-0.6-0.2-0.2-0.5-0.4-0.4-0.1-0.7-0.1h-6.6v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m60 70.1h-4.8q-0.3 0-0.6 0.1-0.4 0.2-0.6 0.4-0.3 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.7q0 0.4 0.1 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.6 0.4 0.3 0.1 0.6 0.1h6.6v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 70.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 70.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 70.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 78.4h4.8q0.3 0 0.6-0.1 0.4-0.2 0.6-0.4 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-4.7q0-0.4-0.1-0.7-0.1-0.3-0.4-0.6-0.2-0.2-0.6-0.4-0.3-0.1-0.6-0.1h-6.6v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 76.6q0 0.4 0.2 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.5 0.4 0.4 0.1 0.7 0.1h6.6v-8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 70.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 70.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m134.8 70.1q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7v6.5h-8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m143.1 78.4q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.4-0.6 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m138.4 78.4q-0.4 0-0.7-0.1-0.3-0.2-0.6-0.4-0.2-0.3-0.4-0.6-0.1-0.3-0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 76.6v-4.7q0-0.4-0.1-0.7-0.1-0.3-0.4-0.6-0.2-0.2-0.6-0.4-0.3-0.1-0.6-0.1h-4.8q-0.4 0-0.7 0.1-0.3 0.2-0.6 0.4-0.2 0.3-0.4 0.6-0.1 0.3-0.1 0.7v6.5h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 76.6v-4.7q0-0.4-0.2-0.7-0.1-0.3-0.4-0.6-0.2-0.2-0.5-0.4-0.4-0.1-0.7-0.1h-4.8q-0.3 0-0.7 0.1-0.3 0.2-0.5 0.4-0.3 0.3-0.4 0.6-0.2 0.3-0.2 0.7v6.5h8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m171.6 78.4q-0.3 0-0.7-0.1-0.3-0.2-0.5-0.4-0.3-0.3-0.4-0.6-0.1-0.3-0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m178.2 71.9c0-1 0.8-1.8 1.7-1.8h4.8c1 0 1.8 0.8 1.8 1.8v4.7c0 1-0.8 1.8-1.8 1.8h-4.8c-0.9 0-1.7-0.8-1.7-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m194.8 71.9c0-1 0.8-1.8 1.8-1.8h4.7c1 0 1.8 0.8 1.8 1.8v4.7c0 1-0.8 1.8-1.8 1.8h-4.7c-1 0-1.8-0.8-1.8-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m3.6 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m11.9 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m20.2 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m28.5 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m38.6 78.4h-1.8v1.8q0-0.4 0.2-0.7 0.1-0.3 0.4-0.6 0.2-0.2 0.5-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m45.1 80.2c0-1 0.8-1.8 1.8-1.8h4.8c1 0 1.8 0.8 1.8 1.8v4.7c0 1-0.8 1.8-1.8 1.8h-4.8c-1 0-1.8-0.8-1.8-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 80.2v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.3 0.6 0.2 0.3 0.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m60 86.7q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.3-0.6 0.2-0.3 0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m71.9 78.4h-1.8v1.8q0-0.4 0.1-0.7 0.2-0.3 0.4-0.6 0.3-0.2 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 80.2v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 78.4h-1.8v1.8q0-0.4 0.2-0.7 0.1-0.3 0.3-0.6 0.3-0.2 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.3 80.2v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.3 0.6 0.2 0.3 0.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.3 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 78.4h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m155 86.7q-0.4 0-0.7-0.1-0.3-0.2-0.6-0.4-0.2-0.3-0.3-0.6-0.2-0.3-0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m161.5 84.9q0 0.4 0.2 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.5 0.4 0.4 0.1 0.7 0.1h6.6v-8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m176.4 78.4q0.4 0 0.7 0.1 0.3 0.2 0.5 0.4 0.3 0.3 0.4 0.6 0.2 0.3 0.2 0.7v6.5h-8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m203.1 80.2c0-1 0.8-1.8 1.8-1.8h4.8c0.9 0 1.7 0.8 1.7 1.8v4.7c0 1-0.8 1.8-1.7 1.8h-4.8c-1 0-1.8-0.8-1.8-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m3.6 86.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m11.9 86.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m22 86.7h-1.8v1.8q0-0.4 0.1-0.7 0.2-0.3 0.4-0.6 0.3-0.2 0.6-0.3 0.3-0.2 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m28.5 88.5v-1.8h-1.7q0.3 0 0.6 0.2 0.4 0.1 0.6 0.3 0.3 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m22 95q-0.4 0-0.7-0.1-0.3-0.1-0.6-0.4-0.2-0.2-0.4-0.6-0.1-0.3-0.1-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m28.5 93.3q0 0.3 0.2 0.6 0.1 0.4 0.3 0.6 0.3 0.3 0.6 0.4 0.3 0.1 0.7 0.1h4.8q0.3 0 0.6-0.1 0.4-0.1 0.6-0.4 0.3-0.2 0.4-0.6 0.1-0.3 0.1-0.6v-6.6h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m60 86.7h-4.8q-0.3 0-0.6 0.2-0.4 0.1-0.6 0.3-0.3 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.8q0 0.3 0.1 0.6 0.1 0.4 0.4 0.6 0.2 0.3 0.6 0.4 0.3 0.1 0.6 0.1h6.6v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 86.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 86.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m93.3 95q0.3 0 0.6-0.1 0.4-0.1 0.6-0.4 0.3-0.2 0.4-0.6 0.1-0.3 0.1-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 95q-0.4 0-0.7-0.1-0.3-0.1-0.6-0.4-0.2-0.2-0.3-0.6-0.2-0.3-0.2-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m96.8 86.7q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.3-0.2 0.3-0.3 0.6-0.2 0.3-0.2 0.7v6.5h8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 86.7h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m113.4 95h4.8q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.3-0.6 0.2-0.3 0.2-0.6v-4.8q0-0.4-0.2-0.7-0.1-0.3-0.3-0.6-0.3-0.2-0.6-0.3-0.3-0.2-0.7-0.2h-6.5v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.3 93.3q0 0.3 0.1 0.6 0.2 0.4 0.4 0.6 0.3 0.3 0.6 0.4 0.3 0.1 0.7 0.1h4.7q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.6 0.1-0.3 0.1-0.6v-6.6h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m138.4 86.7h-1.8v1.8q0-0.4 0.1-0.7 0.2-0.3 0.4-0.6 0.3-0.2 0.6-0.3 0.3-0.2 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 88.5v-1.8h-1.8q0.4 0 0.7 0.2 0.3 0.1 0.6 0.3 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m143.1 95q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.6 0.1-0.3 0.1-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 86.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m155 95h4.8q0.3 0 0.6-0.1 0.4-0.1 0.6-0.4 0.3-0.2 0.4-0.6 0.1-0.3 0.1-0.6v-4.8q0-0.4-0.1-0.7-0.1-0.3-0.4-0.6-0.2-0.2-0.6-0.3-0.3-0.2-0.6-0.2h-6.6v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 88.5v-1.8h-1.8q0.3 0 0.7 0.2 0.3 0.1 0.5 0.3 0.3 0.3 0.4 0.6 0.2 0.3 0.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 93.3q0 0.3 0.1 0.6 0.1 0.4 0.4 0.6 0.2 0.3 0.5 0.4 0.4 0.1 0.7 0.1h4.8q0.4 0 0.7-0.1 0.3-0.1 0.5-0.4 0.3-0.2 0.4-0.6 0.2-0.3 0.2-0.6v-6.6h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m186.5 88.5c0-1 0.8-1.8 1.7-1.8h4.8c1 0 1.8 0.8 1.8 1.8v4.8c0 0.9-0.8 1.7-1.8 1.7h-4.8c-0.9 0-1.7-0.8-1.7-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m3.6 101.6q0 0.3 0.1 0.7 0.1 0.3 0.4 0.5 0.2 0.3 0.6 0.4 0.3 0.1 0.6 0.1h6.6v-8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m11.9 95h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m26.8 95q0.3 0 0.6 0.2 0.4 0.1 0.6 0.3 0.3 0.3 0.4 0.6 0.1 0.3 0.1 0.7v6.5h-8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m30.3 103.3q-0.4 0-0.7-0.1-0.3-0.1-0.6-0.4-0.2-0.2-0.3-0.5-0.2-0.4-0.2-0.7v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m43.4 95h-4.8q-0.4 0-0.7 0.2-0.3 0.1-0.5 0.3-0.3 0.3-0.4 0.6-0.2 0.3-0.2 0.7v4.8q0 0.3 0.2 0.7 0.1 0.3 0.4 0.5 0.2 0.3 0.5 0.4 0.3 0.1 0.7 0.1h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m51.7 95q0.3 0 0.7 0.2 0.3 0.1 0.5 0.3 0.3 0.3 0.4 0.6 0.2 0.3 0.2 0.7v6.5h-8.4v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 96.8v-1.8h-1.8q0.4 0 0.7 0.2 0.3 0.1 0.6 0.3 0.2 0.3 0.3 0.6 0.2 0.3 0.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m55.2 103.3q-0.3 0-0.6-0.1-0.4-0.1-0.6-0.4-0.3-0.2-0.4-0.5-0.1-0.4-0.1-0.7v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 101.6q0 0.3 0.1 0.7 0.1 0.3 0.4 0.5 0.2 0.3 0.6 0.4 0.3 0.1 0.6 0.1h4.8q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.5 0.1-0.4 0.1-0.7v-6.6h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m76.6 103.3q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.5 0.1-0.4 0.1-0.7v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 95h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 95h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 95h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m105.1 95h-1.8v1.8q0-0.4 0.2-0.7 0.1-0.3 0.4-0.6 0.2-0.2 0.5-0.3 0.4-0.2 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 96.8c0-1 0.8-1.8 1.7-1.8h4.8c1 0 1.8 0.8 1.8 1.8v4.8c0 1-0.8 1.7-1.8 1.7h-4.8c-0.9 0-1.7-0.7-1.7-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m143.1 95h-4.7q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.3-0.2 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.8q0 0.3 0.1 0.7 0.2 0.3 0.4 0.5 0.3 0.3 0.6 0.4 0.3 0.1 0.7 0.1h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 101.6q0 0.3-0.1 0.7-0.1 0.3-0.4 0.5-0.2 0.3-0.6 0.4-0.3 0.1-0.6 0.1h-6.6v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m155 95h-1.8v1.8q0-0.4 0.2-0.7 0.1-0.3 0.3-0.6 0.3-0.2 0.6-0.3 0.3-0.2 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m11.9 105.1v-1.8h-1.8q0.4 0 0.7 0.2 0.3 0.1 0.6 0.4 0.2 0.2 0.4 0.5 0.1 0.4 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m11.9 109.9q0 0.3 0.1 0.7 0.2 0.3 0.4 0.5 0.3 0.3 0.6 0.4 0.3 0.2 0.7 0.2h6.5v-8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m20.2 103.3h8.3v8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m35.1 103.3q0.3 0 0.6 0.2 0.4 0.1 0.6 0.4 0.3 0.2 0.4 0.5 0.1 0.4 0.1 0.7v6.6h-8.3v-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m45.1 105.1v-1.8h-1.7q0.3 0 0.7 0.2 0.3 0.1 0.5 0.4 0.3 0.2 0.4 0.5 0.1 0.4 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m38.6 111.7q-0.4 0-0.7-0.2-0.3-0.1-0.5-0.4-0.3-0.2-0.4-0.5-0.2-0.4-0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m45.1 109.9q0 0.3 0.2 0.7 0.1 0.3 0.4 0.5 0.2 0.3 0.5 0.4 0.4 0.2 0.7 0.2h6.6v-8.4h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m55.2 111.7h4.8q0.4 0 0.7-0.2 0.3-0.1 0.6-0.4 0.2-0.2 0.3-0.5 0.2-0.4 0.2-0.7v-4.8q0-0.3-0.2-0.7-0.1-0.3-0.3-0.5-0.3-0.3-0.6-0.4-0.3-0.2-0.7-0.2h-6.5v8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m76.6 103.3h-4.7q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.5-0.1 0.4-0.1 0.7v4.8q0 0.3 0.1 0.7 0.2 0.3 0.4 0.5 0.3 0.3 0.6 0.4 0.3 0.2 0.7 0.2h6.5v-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 109.9q0 0.3-0.1 0.7-0.2 0.3-0.4 0.5-0.3 0.3-0.6 0.4-0.3 0.2-0.7 0.2h-6.5v-8.4h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 103.3h-1.8v1.8q0-0.3 0.2-0.7 0.1-0.3 0.3-0.5 0.3-0.3 0.6-0.4 0.3-0.2 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 105.1v-1.8h-1.7q0.3 0 0.6 0.2 0.4 0.1 0.6 0.4 0.3 0.2 0.4 0.5 0.1 0.4 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 109.9q0 0.3 0.2 0.7 0.1 0.3 0.3 0.5 0.3 0.3 0.6 0.4 0.3 0.2 0.7 0.2h4.8q0.3 0 0.7-0.2 0.3-0.1 0.5-0.4 0.3-0.2 0.4-0.5 0.1-0.4 0.1-0.7v-6.6h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 105.1c0-1 0.7-1.8 1.7-1.8h4.8c1 0 1.8 0.8 1.8 1.8v4.8c0 1-0.8 1.8-1.8 1.8h-4.8c-1 0-1.7-0.8-1.7-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.3 105.1c0-1 0.8-1.8 1.8-1.8h4.7c1 0 1.8 0.8 1.8 1.8v4.8c0 1-0.8 1.8-1.8 1.8h-4.7c-1 0-1.8-0.8-1.8-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m151.5 111.7q0.3 0 0.6-0.2 0.4-0.1 0.6-0.4 0.3-0.2 0.4-0.5 0.1-0.4 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m155 103.3q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.4-0.2 0.2-0.3 0.5-0.2 0.4-0.2 0.7v6.6h8.3v-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m161.5 103.3h8.4v8.4h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 103.3h8.3v8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.9 111.7h4.8q0.4 0 0.7-0.2 0.3-0.1 0.6-0.4 0.2-0.2 0.3-0.5 0.2-0.4 0.2-0.7v-4.8q0-0.3-0.2-0.7-0.1-0.3-0.3-0.5-0.3-0.3-0.6-0.4-0.3-0.2-0.7-0.2h-6.5v8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m201.3 103.3h-4.7q-0.4 0-0.7 0.2-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.5-0.1 0.4-0.1 0.7v4.8q0 0.3 0.1 0.7 0.2 0.3 0.4 0.5 0.3 0.3 0.6 0.4 0.3 0.2 0.7 0.2h6.5v-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m204.9 111.7h4.8q0.3 0 0.6-0.2 0.4-0.1 0.6-0.4 0.3-0.2 0.4-0.5 0.1-0.4 0.1-0.7v-4.8q0-0.3-0.1-0.7-0.1-0.3-0.4-0.5-0.2-0.3-0.6-0.4-0.3-0.2-0.6-0.2h-6.6v8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m11.9 118.2v-4.8q0-0.3-0.1-0.7-0.2-0.3-0.4-0.5-0.3-0.3-0.6-0.4-0.3-0.1-0.7-0.1h-4.8q-0.3 0-0.6 0.1-0.4 0.1-0.6 0.4-0.3 0.2-0.4 0.5-0.1 0.4-0.1 0.7v6.6h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m28.5 113.4v-1.7h-1.7q0.3 0 0.6 0.1 0.4 0.1 0.6 0.4 0.3 0.2 0.4 0.5 0.1 0.4 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m26.8 120q0.3 0 0.6-0.2 0.4-0.1 0.6-0.3 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m28.5 111.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m38.6 120h4.8q0.3 0 0.7-0.2 0.3-0.1 0.5-0.3 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-4.8q0-0.3-0.1-0.7-0.1-0.3-0.4-0.5-0.2-0.3-0.5-0.4-0.4-0.1-0.7-0.1h-6.6v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 113.4c0-1 0.8-1.7 1.8-1.7h4.8c0.9 0 1.7 0.7 1.7 1.7v4.8c0 1-0.8 1.8-1.7 1.8h-4.8c-1 0-1.8-0.8-1.8-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 113.4c0-1 0.8-1.7 1.8-1.7h4.8c1 0 1.8 0.7 1.8 1.7v4.8c0 1-0.8 1.8-1.8 1.8h-4.8c-1 0-1.8-0.8-1.8-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m143.1 111.7h-4.7q-0.4 0-0.7 0.1-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.5-0.1 0.4-0.1 0.7v4.8q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.3 0.3 0.2 0.7 0.2h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 111.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 111.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m161.5 111.7h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 111.7h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.9 111.7h-1.7v1.7q0-0.3 0.1-0.7 0.1-0.3 0.4-0.5 0.2-0.3 0.6-0.4 0.3-0.1 0.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m3.6 120h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m26.8 120h-4.8q-0.4 0-0.7 0.1-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.6-0.1 0.3-0.1 0.6v4.8q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.3 0.3 0.2 0.7 0.2h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m36.8 126.5q0 0.4-0.1 0.7-0.1 0.3-0.4 0.6-0.2 0.2-0.6 0.3-0.3 0.2-0.6 0.2h-6.6v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m38.6 120h-1.8v1.7q0-0.3 0.2-0.6 0.1-0.4 0.4-0.6 0.2-0.3 0.5-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m51.7 120h-4.8q-0.3 0-0.7 0.1-0.3 0.1-0.5 0.4-0.3 0.2-0.4 0.6-0.2 0.3-0.2 0.6v4.8q0 0.4 0.2 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.5 0.3 0.4 0.2 0.7 0.2h6.6v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m53.5 120h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 120h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 120h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m84.9 120q0.4 0 0.7 0.1 0.3 0.1 0.6 0.4 0.2 0.2 0.4 0.6 0.1 0.3 0.1 0.6v6.6h-8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 128.3q-0.4 0-0.7-0.2-0.3-0.1-0.6-0.3-0.2-0.3-0.3-0.6-0.2-0.3-0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 121.7c0-0.9 0.8-1.7 1.7-1.7h4.8c1 0 1.8 0.8 1.8 1.7v4.8c0 1-0.8 1.8-1.8 1.8h-4.8c-0.9 0-1.7-0.8-1.7-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 121.7v-1.7h-1.8q0.4 0 0.7 0.1 0.3 0.1 0.6 0.4 0.2 0.2 0.4 0.6 0.1 0.3 0.1 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 120h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m161.5 126.5q0 0.4-0.1 0.7-0.1 0.3-0.4 0.6-0.2 0.2-0.6 0.3-0.3 0.2-0.6 0.2h-6.6v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m163.3 120h-1.8v1.7q0-0.3 0.2-0.6 0.1-0.4 0.4-0.6 0.2-0.3 0.5-0.4 0.4-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 121.7v-1.7h-1.8q0.3 0 0.7 0.1 0.3 0.1 0.5 0.4 0.3 0.2 0.4 0.6 0.2 0.3 0.2 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 126.5q0 0.4 0.1 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.5 0.3 0.4 0.2 0.7 0.2h4.8q0.4 0 0.7-0.2 0.3-0.1 0.5-0.3 0.3-0.3 0.4-0.6 0.2-0.3 0.2-0.7v-6.5h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m193 120h-4.8q-0.3 0-0.6 0.1-0.4 0.1-0.6 0.4-0.3 0.2-0.4 0.6-0.1 0.3-0.1 0.6v4.8q0 0.4 0.1 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.6 0.3 0.3 0.2 0.6 0.2h6.6v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m194.8 120h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m209.7 120q0.3 0 0.6 0.1 0.4 0.1 0.6 0.4 0.3 0.2 0.4 0.6 0.1 0.3 0.1 0.6v6.6h-8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m3.6 128.3h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m35.1 136.6q0.3 0 0.6-0.1 0.4-0.2 0.6-0.4 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m45.1 134.8v-4.7q0-0.4-0.1-0.7-0.1-0.3-0.4-0.6-0.2-0.2-0.5-0.4-0.4-0.1-0.7-0.1h-4.8q-0.4 0-0.7 0.1-0.3 0.2-0.5 0.4-0.3 0.3-0.4 0.6-0.2 0.3-0.2 0.7v6.5h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m46.9 136.6q-0.3 0-0.7-0.1-0.3-0.2-0.5-0.4-0.3-0.3-0.4-0.6-0.2-0.3-0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 130.1v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.3 0.6 0.2 0.3 0.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m61.8 134.8q0 0.4 0.1 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.6 0.4 0.3 0.1 0.6 0.1h6.6v-8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 128.3h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 128.3h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m93.3 128.3q0.3 0 0.6 0.1 0.4 0.2 0.6 0.4 0.3 0.3 0.4 0.6 0.1 0.3 0.1 0.7v6.5h-8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 134.8v-4.7q0-0.4-0.2-0.7-0.1-0.3-0.4-0.6-0.2-0.2-0.5-0.4-0.4-0.1-0.7-0.1h-4.8q-0.3 0-0.7 0.1-0.3 0.2-0.5 0.4-0.3 0.3-0.4 0.6-0.2 0.3-0.2 0.7v6.5h8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m113.4 136.6q-0.3 0-0.7-0.1-0.3-0.2-0.5-0.4-0.3-0.3-0.4-0.6-0.1-0.3-0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m143.1 136.6q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.4-0.6 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 128.3h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m155 128.3h-1.8v1.8q0-0.4 0.2-0.7 0.1-0.3 0.3-0.6 0.3-0.2 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m155 136.6q-0.4 0-0.7-0.1-0.3-0.2-0.6-0.4-0.2-0.3-0.3-0.6-0.2-0.3-0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m194.8 130.1v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m194.8 134.8q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.4 0.3 0.1 0.7 0.1h6.5v-8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m203.1 128.3h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m3.6 143.1q0 0.4 0.1 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.6 0.4 0.3 0.1 0.6 0.1h4.8q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-6.5h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m35.1 136.6h-4.8q-0.4 0-0.7 0.1-0.3 0.2-0.6 0.4-0.2 0.3-0.3 0.6-0.2 0.3-0.2 0.7v4.7q0 0.4 0.2 0.7 0.1 0.3 0.3 0.6 0.3 0.2 0.6 0.4 0.3 0.1 0.7 0.1h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m36.8 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m45.1 136.6h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m55.2 144.9h4.8q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.3-0.6 0.2-0.3 0.2-0.7v-4.7q0-0.4-0.2-0.7-0.1-0.3-0.3-0.6-0.3-0.2-0.6-0.4-0.3-0.1-0.7-0.1h-6.5v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 138.4v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m76.6 144.9q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.4-0.6 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 143.1q0 0.4 0.2 0.7 0.1 0.3 0.4 0.6 0.2 0.2 0.5 0.4 0.4 0.1 0.7 0.1h6.6v-8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m128.3 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m161.5 136.6h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.9 144.9h4.8q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.3-0.6 0.2-0.3 0.2-0.7v-4.7q0-0.4-0.2-0.7-0.1-0.3-0.3-0.6-0.3-0.2-0.6-0.4-0.3-0.1-0.7-0.1h-6.5v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m203.1 138.4v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m203.1 136.6h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m71.9 144.9q-0.4 0-0.7 0.1-0.3 0.2-0.6 0.4-0.2 0.3-0.4 0.6-0.1 0.3-0.1 0.7v6.5h8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 144.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 144.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m96.8 153.2q-0.4 0-0.7-0.1-0.3-0.1-0.6-0.4-0.2-0.2-0.3-0.6-0.2-0.3-0.2-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 146.7v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.3 0.6 0.2 0.3 0.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m118.2 153.2q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.3-0.6 0.2-0.3 0.2-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 144.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m130.1 144.9h-1.8v1.8q0-0.4 0.1-0.7 0.2-0.3 0.4-0.6 0.3-0.2 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 146.7v-1.8h-1.8q0.4 0 0.7 0.1 0.3 0.2 0.6 0.4 0.2 0.3 0.4 0.6 0.1 0.3 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 144.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m146.7 144.9h-1.8v1.8q0-0.4 0.1-0.7 0.2-0.3 0.4-0.6 0.3-0.2 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 146.7v-1.8h-1.8q0.3 0 0.7 0.1 0.3 0.2 0.5 0.4 0.3 0.3 0.4 0.6 0.2 0.3 0.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 144.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.9 144.9h-1.7v1.8q0-0.4 0.1-0.7 0.1-0.3 0.4-0.6 0.2-0.2 0.6-0.4 0.3-0.1 0.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m201.3 153.2q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.6 0.1-0.3 0.1-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m203.1 144.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 159.8q0 0.3 0.1 0.6 0.2 0.4 0.4 0.6 0.3 0.3 0.6 0.4 0.3 0.1 0.7 0.1h6.5v-8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 153.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 153.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 153.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 153.2h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 153.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 153.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 153.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 155c0-1 0.8-1.8 1.8-1.8h4.8c0.9 0 1.7 0.8 1.7 1.8v4.8c0 0.9-0.8 1.7-1.7 1.7h-4.8c-1 0-1.8-0.8-1.8-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 153.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.9 161.5q-0.3 0-0.6-0.1-0.4-0.1-0.6-0.4-0.3-0.2-0.4-0.6-0.1-0.3-0.1-0.6v1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m193 153.2h-4.8q-0.3 0-0.6 0.2-0.4 0.1-0.6 0.3-0.3 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.8q0 0.3 0.1 0.6 0.1 0.4 0.4 0.6 0.2 0.3 0.6 0.4 0.3 0.1 0.6 0.1h6.6v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m194.8 153.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m211.4 159.8q0 0.3-0.1 0.6-0.1 0.4-0.4 0.6-0.2 0.3-0.6 0.4-0.3 0.1-0.6 0.1h-6.6v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 163.3v-1.8h-1.8q0.4 0 0.7 0.2 0.3 0.1 0.6 0.4 0.2 0.2 0.4 0.5 0.1 0.4 0.1 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m84.9 169.9q0.4 0 0.7-0.2 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.5 0.1-0.4 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 161.5h8.3v8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 161.5h8.3v8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m105.1 161.5h-1.8v1.8q0-0.3 0.2-0.7 0.1-0.3 0.4-0.5 0.2-0.3 0.5-0.4 0.4-0.2 0.7-0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m105.1 169.9q-0.3 0-0.7-0.2-0.3-0.1-0.5-0.4-0.3-0.2-0.4-0.5-0.2-0.4-0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 163.3v-1.8h-1.8q0.4 0 0.7 0.2 0.3 0.1 0.6 0.4 0.2 0.2 0.3 0.5 0.2 0.4 0.2 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m120 168.1q0 0.3 0.1 0.7 0.1 0.3 0.4 0.5 0.2 0.3 0.6 0.4 0.3 0.2 0.6 0.2h4.8q0.4 0 0.7-0.2 0.3-0.1 0.6-0.4 0.2-0.2 0.3-0.5 0.2-0.4 0.2-0.7v-6.6h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 161.5h8.3v8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m146.7 169.9q-0.4 0-0.7-0.2-0.3-0.1-0.6-0.4-0.2-0.2-0.4-0.5-0.1-0.4-0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m168.1 169.9q0.3 0 0.7-0.2 0.3-0.1 0.5-0.4 0.3-0.2 0.4-0.5 0.2-0.4 0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 161.5h8.3v8.4h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m184.7 161.5q0.4 0 0.7 0.2 0.3 0.1 0.6 0.4 0.2 0.2 0.3 0.5 0.2 0.4 0.2 0.7v6.6h-8.3v-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m71.9 169.9q-0.4 0-0.7 0.1-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.5-0.1 0.4-0.1 0.7v6.6h8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 169.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 169.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m95 169.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 169.9h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m113.4 178.2h4.8q0.4 0 0.7-0.2 0.3-0.1 0.6-0.4 0.2-0.2 0.3-0.5 0.2-0.3 0.2-0.7v-4.8q0-0.3-0.2-0.7-0.1-0.3-0.3-0.5-0.3-0.3-0.6-0.4-0.3-0.1-0.7-0.1h-6.5v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m134.8 178.2q0.4 0 0.7-0.2 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.5 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m136.6 169.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 169.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 169.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m161.5 169.9h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 169.9h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m186.5 176.4q0 0.4-0.2 0.7-0.1 0.3-0.3 0.5-0.3 0.3-0.6 0.4-0.3 0.2-0.7 0.2h-6.5v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 178.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 178.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 178.2h-1.8v1.7q0-0.3 0.2-0.6 0.1-0.4 0.3-0.6 0.3-0.3 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 186.5q-0.4 0-0.7-0.2-0.3-0.1-0.6-0.3-0.2-0.3-0.3-0.6-0.2-0.3-0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 179.9v-1.7h-1.7q0.3 0 0.7 0.1 0.3 0.1 0.5 0.4 0.3 0.2 0.4 0.6 0.1 0.3 0.1 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 178.2h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m113.4 178.2h-1.7v1.7q0-0.3 0.1-0.6 0.1-0.4 0.4-0.6 0.2-0.3 0.5-0.4 0.4-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m113.4 186.5q-0.3 0-0.7-0.2-0.3-0.1-0.5-0.3-0.3-0.3-0.4-0.6-0.1-0.3-0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m134.8 178.2h-4.7q-0.4 0-0.7 0.1-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.6-0.1 0.3-0.1 0.6v4.8q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.3 0.3 0.2 0.7 0.2h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 184.7q0 0.4-0.1 0.7-0.2 0.3-0.4 0.6-0.3 0.2-0.6 0.3-0.3 0.2-0.7 0.2h-6.5v-8.3h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m146.7 178.2h-1.8v1.7q0-0.3 0.1-0.6 0.2-0.4 0.4-0.6 0.3-0.3 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 179.9v-1.7h-1.7q0.3 0 0.6 0.1 0.4 0.1 0.6 0.4 0.3 0.2 0.4 0.6 0.1 0.3 0.1 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 184.7q0 0.4 0.2 0.7 0.1 0.3 0.3 0.6 0.3 0.2 0.6 0.3 0.3 0.2 0.7 0.2h4.8q0.3 0 0.6-0.2 0.4-0.1 0.6-0.3 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-6.5h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m163.3 178.2h-1.8v1.7q0-0.3 0.2-0.6 0.1-0.4 0.4-0.6 0.2-0.3 0.5-0.4 0.4-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 179.9v-1.7h-1.8q0.3 0 0.7 0.1 0.3 0.1 0.5 0.4 0.3 0.2 0.4 0.6 0.2 0.3 0.2 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 178.2h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.9 178.2h-1.7v1.7q0-0.3 0.1-0.6 0.1-0.4 0.4-0.6 0.2-0.3 0.6-0.4 0.3-0.1 0.6-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m201.3 178.2h-4.7q-0.4 0-0.7 0.1-0.3 0.1-0.6 0.4-0.2 0.2-0.4 0.6-0.1 0.3-0.1 0.6v4.8q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.3 0.3 0.2 0.7 0.2h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m209.7 178.2q0.3 0 0.6 0.1 0.4 0.1 0.6 0.4 0.3 0.2 0.4 0.6 0.1 0.3 0.1 0.6v6.6h-8.3v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 186.5h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m78.4 186.5h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m88.5 194.8h4.8q0.3 0 0.6-0.1 0.4-0.2 0.6-0.4 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-4.8q0-0.3-0.1-0.6-0.1-0.4-0.4-0.6-0.2-0.3-0.6-0.4-0.3-0.1-0.6-0.1h-6.6v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 186.5h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m111.7 186.5h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m121.7 194.8h4.8q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.3-0.6 0.2-0.3 0.2-0.7v-4.8q0-0.3-0.2-0.6-0.1-0.4-0.3-0.6-0.3-0.3-0.6-0.4-0.3-0.1-0.7-0.1h-6.5v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m168.1 194.8q0.3 0 0.7-0.1 0.3-0.2 0.5-0.4 0.3-0.3 0.4-0.6 0.2-0.3 0.2-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 186.5h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.9 194.8q-0.3 0-0.6-0.1-0.4-0.2-0.6-0.4-0.3-0.3-0.4-0.6-0.1-0.3-0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m186.5 188.2c0-0.9 0.8-1.7 1.7-1.7h4.8c1 0 1.8 0.8 1.8 1.7v4.8c0 1-0.8 1.8-1.8 1.8h-4.8c-0.9 0-1.7-0.8-1.7-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m203.1 188.2v-1.7h-1.8q0.4 0 0.7 0.1 0.3 0.1 0.6 0.4 0.2 0.2 0.4 0.6 0.1 0.3 0.1 0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m203.1 193q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.4 0.3 0.1 0.7 0.1h4.8q0.3 0 0.6-0.1 0.4-0.2 0.6-0.4 0.3-0.3 0.4-0.6 0.1-0.3 0.1-0.7v-6.5h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 194.8h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m80.2 194.8h-1.8v1.8q0-0.4 0.1-0.7 0.2-0.3 0.4-0.6 0.3-0.2 0.6-0.4 0.3-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 194.8h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m113.4 194.8h-1.7v1.8q0-0.4 0.1-0.7 0.1-0.3 0.4-0.6 0.2-0.2 0.5-0.4 0.4-0.1 0.7-0.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m143.1 194.8h-4.7q-0.4 0-0.7 0.1-0.3 0.2-0.6 0.4-0.2 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.7q0 0.4 0.1 0.7 0.2 0.3 0.4 0.6 0.3 0.2 0.6 0.4 0.3 0.1 0.7 0.1h6.5v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m144.9 194.8h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m153.2 194.8h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m161.5 194.8h8.4v8.3h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m169.9 194.8h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m179.9 203.1h4.8q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.3-0.6 0.2-0.3 0.2-0.7v-4.7q0-0.4-0.2-0.7-0.1-0.3-0.3-0.6-0.3-0.2-0.6-0.4-0.3-0.1-0.7-0.1h-6.5v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m193 203.1q0.4 0 0.7-0.1 0.3-0.2 0.6-0.4 0.2-0.3 0.4-0.6 0.1-0.3 0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m203.1 201.3v-4.7q0-0.4-0.1-0.7-0.2-0.3-0.4-0.6-0.3-0.2-0.6-0.4-0.3-0.1-0.7-0.1h-4.7q-0.4 0-0.7 0.1-0.3 0.2-0.6 0.4-0.2 0.3-0.4 0.6-0.1 0.3-0.1 0.7v6.5h8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m204.9 203.1q-0.4 0-0.7-0.1-0.3-0.2-0.6-0.4-0.2-0.3-0.4-0.6-0.1-0.3-0.1-0.7v1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m70.1 209.7q0 0.3 0.1 0.6 0.2 0.4 0.4 0.6 0.3 0.3 0.6 0.4 0.3 0.1 0.7 0.1h4.7q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.6 0.1-0.3 0.1-0.6v-6.6h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m86.7 204.9c0-1 0.8-1.8 1.8-1.8h4.8c0.9 0 1.7 0.8 1.7 1.8v4.8c0 0.9-0.8 1.7-1.7 1.7h-4.8c-1 0-1.8-0.8-1.8-1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m103.3 209.7q0 0.3 0.2 0.6 0.1 0.4 0.4 0.6 0.2 0.3 0.5 0.4 0.4 0.1 0.7 0.1h4.8q0.3 0 0.7-0.1 0.3-0.1 0.5-0.4 0.3-0.2 0.4-0.6 0.2-0.3 0.2-0.6v-6.6h-8.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m126.5 203.1h-4.8q-0.3 0-0.6 0.1-0.4 0.2-0.6 0.4-0.3 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.8q0 0.3 0.1 0.6 0.1 0.4 0.4 0.6 0.2 0.3 0.6 0.4 0.3 0.1 0.6 0.1h6.6v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m130.1 211.4h4.7q0.4 0 0.7-0.1 0.3-0.1 0.6-0.4 0.2-0.2 0.4-0.6 0.1-0.3 0.1-0.6v-4.8q0-0.4-0.1-0.7-0.2-0.3-0.4-0.6-0.3-0.2-0.6-0.4-0.3-0.1-0.7-0.1h-6.5v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m193 203.1h-4.8q-0.3 0-0.6 0.1-0.4 0.2-0.6 0.4-0.3 0.3-0.4 0.6-0.1 0.3-0.1 0.7v4.8q0 0.3 0.1 0.6 0.1 0.4 0.4 0.6 0.2 0.3 0.6 0.4 0.3 0.1 0.6 0.1h6.6v-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m194.8 203.1h8.3v8.3h-8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m204.9 211.4h4.8q0.3 0 0.6-0.1 0.4-0.1 0.6-0.4 0.3-0.2 0.4-0.6 0.1-0.3 0.1-0.6v-4.8q0-0.4-0.1-0.7-0.1-0.3-0.4-0.6-0.2-0.2-0.6-0.4-0.3-0.1-0.6-0.1h-6.6v8.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m60 3.6c1 0 1.8 0.8 1.8 1.7v54.7c0 1-0.8 1.8-1.8 1.8h-54.7c-0.9 0-1.7-0.8-1.7-1.8v-54.7c0-0.9 0.8-1.7 1.7-1.7zm-6.5 9.3c0-0.5-0.5-1-1-1h-39.6c-0.5 0-1 0.4-1 1v39.5c0 0.6 0.5 1.1 1 1.1h39.6c0.5 0 1-0.5 1-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m45.1 36.8v-8.3-6.5c0-1-0.7-1.8-1.7-1.8h-21.4c-1 0-1.8 0.8-1.8 1.8v6.5 8.3 6.6c0 1 0.8 1.8 1.8 1.8h21.4c0.9 0 1.7-0.8 1.7-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m209.7 3.6c0.9 0 1.7 0.8 1.7 1.7v54.7c0 1-0.8 1.8-1.7 1.8h-54.7c-1 0-1.8-0.8-1.8-1.8v-54.7c0-0.9 0.8-1.7 1.8-1.7zm-6.6 9.3c0-0.5-0.4-1-1-1h-39.5c-0.6 0-1 0.4-1 1v39.5c0 0.6 0.4 1.1 1 1.1h39.5c0.6 0 1-0.5 1-1.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m194.8 36.8v-8.3-6.5c0-1-0.8-1.8-1.8-1.8h-21.4c-1 0-1.8 0.8-1.8 1.8v6.5 8.3 6.6c0 1 0.8 1.8 1.8 1.8h21.4c1 0 1.8-0.8 1.8-1.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s1",
    d: "m60 153.2c1 0 1.8 0.8 1.8 1.8v54.7c0 0.9-0.8 1.7-1.8 1.7h-54.7c-0.9 0-1.7-0.8-1.7-1.7v-54.7c0-1 0.8-1.8 1.7-1.8zm-6.5 9.4c0-0.6-0.5-1.1-1-1.1h-39.6c-0.5 0-1 0.5-1 1.1v39.5c0 0.5 0.5 1 1 1h39.6c0.5 0 1-0.4 1-1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m45.1 186.5v-8.3-6.6c0-1-0.7-1.8-1.7-1.8h-21.4c-1 0-1.8 0.8-1.8 1.8v6.6 8.3 6.5c0 1 0.8 1.8 1.8 1.8h21.4c0.9 0 1.7-0.8 1.7-1.8z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "FrameBody",
    fillRule: "evenodd",
    className: "s1",
    d: "m246.9 293.8c0 19.8-16.1 35.9-35.9 35.9h-207.1c-19.8 0-35.9-16.1-35.9-35.9 0-19.9 16.1-36 35.9-36h207.2c19.8 0 35.9 16.1 35.8 36zm0.2-312.1v251.7c0 7.6-6.2 13.7-13.7 13.7h-251.7c-7.6 0-13.7-6.2-13.7-13.7v-251.7c0-7.6 6.1-13.7 13.7-13.7h251.6c7.6 0 13.7 6.1 13.8 13.7zm-10.6 4.2c0-4.1-3.3-7.4-7.4-7.4h-243.2c-4.1 0-7.4 3.3-7.4 7.4v243.2c0 4.1 3.3 7.4 7.4 7.4h243.2c4.1 0 7.4-3.3 7.4-7.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "IconCircle",
    className: "s1",
    d: "m3.9 265.2c-15.8 0-28.5 12.7-28.5 28.5 0 15.8 12.7 28.5 28.5 28.5 15.8 0 28.5-12.7 28.5-28.5 0-15.7-12.7-28.5-28.5-28.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "IconCircle",
    className: "s1",
    d: "m3.9 265.2c-15.8 0-28.5 12.7-28.5 28.5 0 15.8 12.7 28.5 28.5 28.5 15.8 0 28.5-12.7 28.5-28.5 0-15.7-12.7-28.5-28.5-28.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "IconCircleOutline",
    fillRule: "evenodd",
    className: "s1",
    d: "m32.4 293.7c0 15.8-12.7 28.5-28.5 28.5-15.8 0-28.5-12.7-28.5-28.5 0-15.8 12.7-28.5 28.5-28.5 15.8 0 28.5 12.8 28.5 28.5zm-55 0c0 14.6 11.9 26.5 26.5 26.5 14.6 0 26.5-11.9 26.5-26.5 0-14.6-11.9-26.5-26.5-26.5-14.6 0-26.5 11.9-26.5 26.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "PhoneIcon",
    fillRule: "evenodd",
    className: "s1",
    d: "m16.2 275.5v36c0 2.3-1.9 4.1-4.1 4.1h-17.7c-2.3 0-4.1-1.9-4.1-4.1v-36c0-2.3 1.9-4.1 4.1-4.1h17.7c2.2 0 4.1 1.9 4.1 4.1zm-18.3 0.2c0 1.1 0.9 1.9 1.9 1.9h6.8c1.1 0 1.9-0.9 1.9-1.9 0-1-0.9-1.9-1.9-1.9h-6.7c-1.1 0-2 0.8-2 1.9zm15.2 4.7l-19.9-0.2v26.6h19.9zm-12.6 30.8c0 1.4 1.3 2.7 2.7 2.7 1.4 0 2.7-1.3 2.7-2.7 0-1.4-1.3-2.7-2.7-2.7-1.4-0.1-2.7 1.2-2.7 2.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "PhoneIconBlack",
    fillRule: "evenodd",
    className: "s1",
    d: "m16.2 275.5v36c0 2.3-1.9 4.1-4.1 4.1h-17.7c-2.3 0-4.1-1.9-4.1-4.1v-36c0-2.3 1.9-4.1 4.1-4.1h17.7c2.2 0 4.1 1.9 4.1 4.1zm-18.3 0.2c0 1.1 0.9 1.9 1.9 1.9h6.8c1.1 0 1.9-0.9 1.9-1.9 0-1-0.9-1.9-1.9-1.9h-6.7c-1.1 0-2 0.8-2 1.9zm15.2 4.7l-19.9-0.2v26.6h19.9zm-12.6 30.8c0 1.4 1.3 2.7 2.7 2.7 1.4 0 2.7-1.3 2.7-2.7 0-1.4-1.3-2.7-2.7-2.7-1.4-0.1-2.7 1.2-2.7 2.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "TextArea"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m54.4 284.5q-2.8 0-4.5 3-1.6 3-1.6 8.2 0 5.3 1.6 8.2 1.6 2.9 4.5 2.9 1.9 0 4.3-1.1v3.1q-1.2 0.6-2.2 0.8-1 0.3-2.4 0.3-3.9 0-6-3.7-2.1-3.8-2.1-10.6 0-4.3 1-7.5 1-3.2 2.9-4.9 1.9-1.8 4.6-1.8 2.8 0 4.9 1.7l-0.9 2.9q-2.2-1.5-4.1-1.5zm9.9 4.2v13.4q0 2.5 0.7 3.7 0.7 1.3 2.2 1.3 2.1 0 3-1.8 1-1.8 1-5.8v-10.8h2.1v20.8h-1.7l-0.4-2.7h-0.1q-0.6 1.5-1.7 2.3-1 0.8-2.5 0.8-2.4 0-3.6-1.8-1.2-1.8-1.2-5.8v-13.6zm21.9 15.1q0 2.9-1.4 4.5-1.4 1.6-3.9 1.6-2.6 0-4.2-1.3v-3.1q2.2 1.6 4.3 1.6 1.6 0 2.4-0.8 0.7-0.8 0.7-2.2 0-1.3-0.7-2.1-0.7-0.9-2.6-2-1.9-1.1-2.6-1.9-0.8-0.8-1.1-1.8-0.4-1-0.4-2.5 0-2.5 1.3-4 1.4-1.5 3.7-1.5 2.3 0 4.2 1.4l-0.7 2.7q-2-1.3-3.6-1.3-1.4 0-2.1 0.7-0.7 0.7-0.7 1.8 0 1.2 0.6 1.9 0.6 0.8 2.8 2.1 1.7 1 2.5 1.8 0.8 0.8 1.1 1.9 0.4 1 0.4 2.5zm7.7 3.3q0.4 0 1-0.1 0.5-0.2 0.8-0.3v2.6q-0.3 0.2-0.9 0.4-0.6 0.2-1.3 0.2-3.9 0-3.9-6.4v-12.1h-1.9v-1.7l1.9-1.3 0.9-4.5h1.3v4.8h3.8v2.7h-3.8v12q0 1.8 0.6 2.7 0.5 1 1.5 1zm16-8q0 5.1-1.6 7.9-1.6 2.9-4.6 2.9-1.8 0-3.2-1.3-1.3-1.4-2.1-3.8-0.7-2.5-0.7-5.7 0-5.1 1.6-7.9 1.6-2.9 4.5-2.9 2.8 0 4.5 2.9 1.6 2.9 1.6 7.9zm-10 0q0 3.9 1 5.9 1 2.1 2.9 2.1 1.9 0 2.9-2.1 1-2 1-5.9 0-4-1-5.9-1-2-2.9-2-3.9 0-3.9 7.9zm30.4 10.4v-13.4q0-4.9-2.7-4.9-1.8 0-2.7 1.7-0.9 1.7-0.9 5.1v11.5h-2.1v-13.4q0-2.4-0.7-3.7-0.7-1.2-2.1-1.2-1.8 0-2.7 1.8-0.8 1.7-0.8 5.7v10.8h-2.2v-20.8h1.8l0.3 2.9h0.1q0.6-1.6 1.6-2.4 1-0.9 2.3-0.9 3.2 0 4.1 3.5h0.1q0.7-1.6 1.8-2.6 1.1-0.9 2.5-0.9 2.2 0 3.4 1.9 1.1 1.8 1.1 5.8v13.5zm11.9 0.4q-3 0-4.7-2.9-1.7-2.8-1.7-7.7 0-5 1.6-8 1.6-3 4.3-3 2.5 0 4 2.6 1.5 2.5 1.5 6.8v2.1h-9.1q0 3.5 1.1 5.3 1.1 1.9 3.1 1.9 1.1 0 2-0.3 1-0.3 2.3-1.2v3q-1.1 0.8-2.1 1.1-1 0.3-2.3 0.3zm-0.5-18.8q-1.6 0-2.5 1.6-0.9 1.6-1.1 4.4h6.8q0-3-0.9-4.5-0.8-1.5-2.3-1.5zm15-2.8q0.9 0 1.6 0.3l-0.3 3.1q-0.7-0.3-1.4-0.3-1.1 0-2 0.9-0.9 1-1.4 2.6-0.5 1.6-0.5 3.5v11.1h-2.2v-20.8h1.8l0.3 3.8h0.1q0.7-2 1.8-3.1 1-1.1 2.2-1.1zm21.9 21.2l-2.1-8.6h-7l-2.1 8.6h-2.3l6.9-27.8h2.1l6.9 27.8zm-2.8-11.7l-2-8.4-0.9-4.1q-0.3 2.3-0.7 4.1l-2 8.4zm13.5 12.1q-2.7 0-4.1-3h-0.2l0.1 0.7q0.1 1.5 0.1 2.7v8.5h-2.2v-30.1h1.8l0.3 2.9h0.1q0.8-1.8 1.8-2.5 1-0.8 2.3-0.8 2.6 0 4 2.8 1.5 2.9 1.5 8 0 5.1-1.5 7.9-1.4 2.9-4 2.9zm-0.4-18.7q-1.9 0-2.8 1.7-0.9 1.8-0.9 5.5v0.7q0 4.2 0.9 6.1 0.9 1.9 2.9 1.9 1.7 0 2.6-2.2 0.9-2.1 0.9-5.9 0-3.8-0.9-5.8-0.9-2-2.7-2zm15.7 18.7q-2.7 0-4.2-3h-0.1v0.7q0.1 1.5 0.1 2.7v8.5h-2.1v-30.1h1.8l0.2 2.9h0.1q0.8-1.8 1.8-2.5 1-0.8 2.4-0.8 2.6 0 4 2.8 1.4 2.9 1.4 8 0 5.1-1.4 7.9-1.4 2.9-4 2.9zm-0.4-18.7q-2 0-2.9 1.7-0.8 1.8-0.9 5.5v0.7q0 4.2 0.9 6.1 0.9 1.9 2.9 1.9 1.7 0 2.7-2.2 0.9-2.1 0.9-5.9 0-3.8-0.9-5.8-1-2-2.7-2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerQr);
export default __webpack_public_path__ + "static/media/customer_qr.b28c601b33d820421b2bef2aec18ad92.svg";
export { ForwardRef as ReactComponent };